import { collectionArgsConfig, collectionFieldArgsConfig } from '../../utils/event_constants';

export const getPaperFormat = (dimension = false) => {
  let paperFormat = [
    { label: 'A0 (84.1cm x 118.9cm)', value: 'A0:84.1:118.9' },
    { label: 'A1 (59.4cm x 84.1cm)', value: 'A1:59.4:84.1' },
    { label: 'A2 (42.0cm x 59.4cm)', value: 'A2:42.0:59.4' },
    { label: 'A3 (29.7cm x 42.0cm)', value: 'A3:29.7:42.0' },
    { label: 'A4 (21.0cm x 29.7cm)', value: 'A4:21.0:29.7' },
    { label: 'A5 (14.8cm x 21.0cm)', value: 'A5:14.8:21.0' },
    { label: 'A6 (10.5cm x 14.8cm)', value: 'A6:10.5:14.8' },
    { label: 'Letter (21.6cm x 27.9cm)', value: 'Letter:21.6:27.9' },
    { label: 'Legal (21.6cm x 35.6cm)', value: 'Legal:21.6:35.6' },
    { label: 'Tabloid (27.9cm x 43.2cm)', value: 'Tabloid:27.9:43.2' },
    { label: 'Ledger (43.2cm x 27.9cm)', value: 'Ledger:43.2:27.9' },
  ];
  if (!dimension) {
    paperFormat = paperFormat.map((format) => ({
      label: format.label,
      value: format.value.split(':')[0],
    }));
  }
  return paperFormat;
};

export const pdfActions = [
  {
    name: 'generatePdfFromSnippet',
    label: 'Generate PDF from PDF Template',
    args: [
      {
        name: 'pdfTemplate',
        label: 'PDF Template',
        type: 'dropdown',
        optionsType: 'pdfTemplateApi',
        value: '',
      },
      {
        name: 'sendItemIdFrom',
        label: 'Send Item ID From',
        type: 'dropdown',
        optionsType: '',
        options: [],
        value: 'sendCurrentObjectID',
      },
      {
        name: 'bslCollection',
        label: 'Item Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'dropdown',
        optionsType: 'browserStorageLocationOptions',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'itemIdBSLKey',
        label: 'Item ID JSON Key',
        type: 'text',
        value: '',
      },
      {
        name: 'format',
        label: 'Format',
        type: 'dropdown',
        optionsType: 'formatApi',
        value: 'A4',
      },
      {
        name: 'printBackground',
        label: 'Print Background',
        type: 'boolean',
        optionsType: 'printBackgroundApi',
        value: true,
      },
      {
        name: 'landscape',
        label: 'Landscape orientation',
        type: 'boolean',
        optionsType: 'landscapeApi',
        value: false,
      },
      {
        name: 'displayHeader',
        label: 'Display Header',
        type: 'boolean',
        optionsType: 'displayHeaderApi',
        value: false,
      },
      {
        name: 'headerTemplate',
        label: 'Header Template',
        type: 'dropdown',
        optionsType: 'pdfTemplateApi',
        value: '',
      },
      {
        name: 'displayFooter',
        label: 'Display Footer',
        type: 'boolean',
        optionsType: 'displayFooterApi',
        value: false,
      },
      {
        name: 'footerTemplate',
        label: 'Footer Template',
        type: 'dropdown',
        optionsType: 'pdfTemplateApi',
        value: '',
      },
      {
        name: 'generatePDFName',
        label: 'Generate PDF name using a collection field.',
        type: 'boolean',
        optionsType: 'generatePDFNameApi',
        value: false,
      },
      {
        name: 'pdfNameField',
        label: 'PDF Name Field',
        type: 'dropdown',
        optionsType: 'pdfNameFieldApi',
        value: '',
      },
      {
        name: 'marginTop',
        label: 'Margin Top (in cm)',
        type: 'number',
        optionsType: 'marginTopApi',
        value: 0,
      },
      {
        name: 'marginBottom',
        label: 'Margin Bottom (in cm)',
        type: 'number',
        optionsType: 'marginBottomApi',
        value: 0,
      },
      {
        name: 'marginLeft',
        label: 'Margin Left (in cm)',
        type: 'number',
        optionsType: 'marginLeftApi',
        value: 0,
      },
      {
        name: 'marginRight',
        label: 'Margin Right (in cm)',
        type: 'number',
        optionsType: 'marginRightApi',
        value: 0,
      },
      {
        name: 'saveToCollection',
        label: 'Add To Collection',
        type: 'boolean',
        value: false,
      },
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionField' }),
      {
        name: 'downloadSavedPDF',
        label: 'Download Saved PDF',
        type: 'boolean',
        value: true,
      },
    ],
  },
  {
    name: 'generatePdfFromSection',
    label: 'Generate PDF from Page/Snippet Component',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'showComponentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'showComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'showComponents',
        label: 'Show Component',
        type: 'dropdown',
        optionsType: 'showPageComponents',
        options: [],
        value: '',
      },
      {
        name: 'format',
        label: 'Format',
        type: 'dropdown',
        optionsType: 'formatApi',
        options: getPaperFormat(true),
        value: 'A4:21.0:29.7',
      },
      {
        name: 'landscape',
        label: 'Landscape orientation',
        type: 'boolean',
        optionsType: 'landscapeApi',
        value: false,
      },
      {
        name: 'marginTop',
        label: 'Margin Top (in cm)',
        type: 'number',
        optionsType: 'marginTopApi',
        value: 0,
      },
      {
        name: 'marginBottom',
        label: 'Margin Bottom (in cm)',
        type: 'number',
        optionsType: 'marginBottomApi',
        value: 0,
      },
      {
        name: 'marginLeft',
        label: 'Margin Left (in cm)',
        type: 'number',
        optionsType: 'marginLeftApi',
        value: 0,
      },
      {
        name: 'marginRight',
        label: 'Margin Right (in cm)',
        type: 'number',
        optionsType: 'marginRightApi',
        value: 0,
      },
      {
        name: 'saveToCollection',
        label: 'Add To Collection',
        type: 'boolean',
        value: false,
      },
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionField' }),
    ],
  },
  {
    name: 'generatePDFWithBrowserAPI',
    label: 'Generate PDF from Page/Snippet Component V2',
    alertMessage: 'Best result with Chrome & Firefox browsers.',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'showComponentPage',
        label: 'Page',
        type: 'dropdown',
        optionsType: 'showComponentPageApi',
        options: [],
        value: '',
      },
      {
        name: 'showComponents',
        label: 'Show Component',
        type: 'dropdown',
        optionsType: 'showPageComponents',
        options: [],
        value: '',
      },
    ],
  },
  {
    name: 'generatePdfFromAgreementTemplate',
    label: 'Generate PDF from Agreement Template',
    args: [
      {
        name: 'agreementTemplate',
        label: 'Agreement Template',
        type: 'dropdown',
        optionsType: 'agreementTemplatePdfApi',
        value: '',
      },
      {
        name: 'format',
        label: 'Format',
        type: 'dropdown',
        optionsType: 'formatApi',
        options: getPaperFormat(),
        value: 'A4',
      },
      {
        name: 'marginTop',
        label: 'Margin Top (in cm)',
        type: 'number',
        optionsType: 'marginTopApi',
        value: 0,
      },
      {
        name: 'marginBottom',
        label: 'Margin Bottom (in cm)',
        type: 'number',
        optionsType: 'marginBottomApi',
        value: 0,
      },
      {
        name: 'marginLeft',
        label: 'Margin Left (in cm)',
        type: 'number',
        optionsType: 'marginLeftApi',
        value: 0,
      },
      {
        name: 'marginRight',
        label: 'Margin Right (in cm)',
        type: 'number',
        optionsType: 'marginRightApi',
        value: 0,
      },
      {
        name: 'saveToCollection',
        label: 'Add To Collection',
        type: 'boolean',
        value: false,
      },
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionField' }),
    ],
  },
];
